import * as _ from 'underscore';
import { IGroupBasicInfo } from '../models/IGroupInfo';
import { Module } from '../Module';
import { SearchActiveDirectoryGroupNameRequest } from '../ServerApi/requests/SearchActiveDirectoryGroupNameRequest';
import { GrantLicenseModes, SyncActiveDirectoryGroupRequest } from '../ServerApi/requests/SyncActiveDirectoryGroupRequest';
import {
  IActiveDirectoryGroup,
  SyncActiveDirectoryGroupsRequest,
} from '../ServerApi/requests/SyncActiveDirectoryGroupsRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';

const basicGroupInfoToAdGroup = (group: IGroupBasicInfo): IActiveDirectoryGroup => {
  return {
    name: group.name,
    domainName: group.domainName
  };
};

export class ActiveDirectoryGroups {

  public static $inject = ['ErrorNotifyingServer'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer) {}

  // search for active directory groups
  public searchActiveDirectoryGroupName(searchInputText: string): ng.IPromise<any> {
    const request = new SearchActiveDirectoryGroupNameRequest({name: searchInputText});
    return this.ErrorNotifyingServer.sendRequest(request);
  }

  // synchronize a group, if the group does not exist then it will be added
  public syncAdGroup(groupName: string, groupDomainName: string, siteRole?: string, grantLicenseMode?: GrantLicenseModes): ng.IPromise<any> {
    const request = new SyncActiveDirectoryGroupRequest({
      name: groupName,
      domainName: groupDomainName,
      siteRole: siteRole,
      grantLicenseMode: grantLicenseMode
    });
    return this.ErrorNotifyingServer.sendRequest(request);
  }

  // synchronize groups
  public syncAdGroups(groups: IGroupBasicInfo[]): ng.IPromise<IResult> {
    const adGroups = _.map(groups, basicGroupInfoToAdGroup);
    const request = new SyncActiveDirectoryGroupsRequest(adGroups);
    return this.ErrorNotifyingServer.sendRequest(request);
  }

}

Module.instance().service('ActiveDirectoryGroups', ActiveDirectoryGroups);
